import React from "react";
import { Link } from "react-router-dom";
import withRouter from "../services/withRouter";
import Modal from 'react-bootstrap/Modal';
import Login from "./Login/Login";

class Header extends React.Component {

	componentDidMount = async () => {
		window.googleTranslateElementInit = () => {
			new window.google.translate.TranslateElement(
				{
					pageLanguage: 'en',
					includedLanguages: 'en,hi,mr,te,kn,ml,pa,gu,mai,bn,as,gom,or,ur,ta,mai,sa',
				},
				'google_translate_element'
			);
		};

		const existingScript = document.querySelector('script[src*="translate_a/element.js"]');
		if (!existingScript) {
			const addScript = document.createElement('script');
			addScript.setAttribute('src', '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
			document.body.appendChild(addScript);
		} else if (window.google && window.google.translate) {
			window.googleTranslateElementInit();
		}

		// Compact the default Google Translate option text dynamically
		const interval = setInterval(() => {
			const selectEl = document.querySelector('select.goog-te-combo');
			if (selectEl) {
				const firstOpt = selectEl.options[0];
				if (firstOpt && (firstOpt.text === 'Select Language' || firstOpt.textContent === 'Select Language')) {
					firstOpt.text = 'Language';
					firstOpt.textContent = 'Language';
					clearInterval(interval);
				}
			}
		}, 100);
		setTimeout(() => clearInterval(interval), 15000);
	};



	constructor(props) {
		super(props);
		this.state = {
			'show_disclaimer': false
		};
	}


	showDisclaimer = async () => {
		var show_disclaimer = await localStorage.getItem('show_disclaimer') || 2;
		this.setState({ 'show_disclaimer': show_disclaimer == 1 ? false : true });
	}


	handleDisclaimer = async () => {
		await localStorage.setItem('show_disclaimer', 1);
		this.setState({ 'show_disclaimer': false })
	}

	render() {
		return (
			<>
				<Modal show={this.state.show_disclaimer} centered onHide={() => { this.handleDisclaimer() }}>
					<Modal.Header closeButton>
					</Modal.Header>

					<Modal.Body>
						<div className="justify-content-center d-flex align-items-center flex-column py-5" style={{ 'backgroundImage': "url(" + "/assets/img/popup.png" + ")", 'backgroundPosition': 'center', 'backgroundSize': 'cover', 'backgroundRepeat': 'no-repeat' }}>
							<img src="/assets/img/logo.png" alt="logo" style={{ 'width': '100px' }} />
							<div className="d-flex flex-column justify-content-center align-items-center mt-2">
								<h2 style={{ 'color': '#FFD700', 'fontWeight': 'bold' }}>SAHYOG SETU PORTAL</h2>

								<h4 className="mt-4 py-2 px-3" style={{ 'color': 'var(--white-color)', background: '#212530', 'fontWeight': 'bold', 'borderRadius': '50px' }}>DISCLAIMER</h4>

							</div>
							<div className="mt-5 px-3">
								<p className="px-3 py-3" style={{ 'color': '#000000', textAlign: 'justify', background: '#FFD700' }}>The Uplift Live Foundation does not charge any fees from beneficiaries for using the "SAHYOG SETU PORTAL". If any individual or organisation demands any type of fee in the name of the SAHYOG SETU PORTAL, do not provide them with any amount. Otherwise, Uplift Live Foundation will not be responsible for any losses, inconveniences, or legal liabilities arising from such unwanted engagements.</p>
							</div>
						</div>
					</Modal.Body>
				</Modal>

				<header className="main_header_arae shadow">
					<div className="navbar-area">
						<div className="main-navbar shadow">
							<div className="px-3 px-md-5">
								<nav className="navbar d-flex justify-content-between align-items-center w-100 py-2">
									<div className="navbar-brand d-flex align-items-center m-0">
										<Link to={'/home'}><img src="/assets/img/logo.png" alt="logo" className="brand-logo-img" style={{ 'transition': 'all 0.3s ease' }} /></Link>
										<div className="d-flex flex-column align-items-start mx-2 px-2 logo-title" style={{ 'borderLeft': "2.5px solid var(--main-color)", 'padding': '2px 0' }}>
											<Link to={'/home'}><span className="mx-4 mx-md-3 brand-logo-text" style={{ 'color': 'var(--main-color)', 'fontWeight': '800', 'transition': 'all 0.3s ease' }}>SAHYOG SETU</span></Link>
											<Link to="https://www.upliftlivefoundation.org/" target="__blank" className="d-none d-sm-inline"><span className="mx-3 mt-1 text-muted" style={{ fontSize: '11px', 'fontWeight': '500' }}>Uplift Live Foundation</span></Link>
										</div>
									</div>
									<div className="d-flex align-items-center justify-content-end">
										<div className="others-options d-flex align-items-center">
											<div className="option-item mx-1 mx-md-2">
												<div id="google_translate_element"></div>
											</div>
											<div className="option-item mx-2">
												<Login showDisclaimer={this.showDisclaimer}></Login>
											</div>
										</div>
									</div>
								</nav>
							</div>
						</div>
					</div>
				</header>
			</>
		);
	}
}

export default withRouter(Header);
